import { CommentViewController } from "./CommentViewController";
export default CommentViewController;
//# sourceMappingURL=index.js.mapimport { CommentViewController } from "./CommentViewController";
export default CommentViewController;
//# sourceMappingURL=index.js.map